import React, {useState, useEffect} from 'react';
import { BASE_URL_OPENFORGE, IMAGE_PATH, BASE_URL_API, CLIENT_ID, CLIENT_SECRET } from './Constants';
import { analytics } from './Firebase';
import { logEvent } from 'firebase/analytics';
import axios from 'axios';
import crypto from 'crypto-js';

export const Footer = () => {
    const [visitorCount, setVisitorCount] = useState(0);
    const [previousDay, setPreviousDay] = useState('');

    useEffect(() => {
        logEvent(analytics, 'footer_interaction');

        // Get the current date
        const currentDate = new Date();

        // Subtract one day from the current date
        const oneDayEarlier = new Date(currentDate);
        oneDayEarlier.setDate(currentDate.getDate() - 1);

        // Format the date as "Month Day, Year"
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = oneDayEarlier.toLocaleDateString('en-US', options);

        // console.log("formattedDate", formattedDate);
        setPreviousDay(formattedDate);
    }, []);

    useEffect(() => {
        const handleVisitorCount = async () => {
            try {
                const fd = new FormData();
                const ts = Math.floor(Date.now() / 1000);
                const hmacStr = CLIENT_SECRET + CLIENT_ID + ts.toString();
                const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);
                fd.append("client_id", CLIENT_ID);
                fd.append("ts", ts);
                fd.append("hmac", hmacHash);

                const response = await axios.post(`${BASE_URL_API}visitor/count`,fd);
                // console.log("response 23", response.data);
                if(response.data.status === "success"){
                    setVisitorCount(response.data.data.total_visitor_count);
                }
            } catch (error) {
                setVisitorCount(0);
            }
        };

        handleVisitorCount();
    }, []);

    useEffect(() => {
    const fixTabIndex = () => {
    const elements = document.querySelectorAll('[tabindex]');

    elements.forEach(el => {
      const tabIndex = parseInt(el.getAttribute('tabindex'), 10);

      if (tabIndex > 0) {
        el.setAttribute('tabindex', '0');
      }
    });
  };

  // Run repeatedly (handles late injections)
  const interval = setInterval(fixTabIndex, 500);

  // Observe DOM + attribute changes
  const observer = new MutationObserver(() => {
    fixTabIndex();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['tabindex'],
  });

  return () => {
    clearInterval(interval);
    observer.disconnect();
  };
}, []);

  return (
    <>
        <footer className="bg-dark text-light py-4" id="mob_foot2">
            <div className="container">
                <div className="row">
                    <div className="col-md-3 mb-3" id="mob_foot3">
                        <h2 id="mob_foot1"  className="text-start" style={{ fontSize:'1.25rem'}} >OpenForge</h2>
                        <ul className="list-unstyled">
                            <li><a href={`${BASE_URL_OPENFORGE}/openforge/about.php`} className="text-light text-decoration-none">About</a></li>
                            <li><a href={`${BASE_URL_OPENFORGE}/openforge/faq.php`} className="text-light text-decoration-none">FAQs</a></li>
                            <li><a href={`${BASE_URL_OPENFORGE}/openforge/privacypolicy.php`} className="text-light text-decoration-none">Privacy Policy</a></li>
                            <li><a href={`${BASE_URL_OPENFORGE}/openforge/Terms_of_Use.php`}  className="text-light text-decoration-none">Terms of Service</a></li>
                            <li><a href={`${BASE_URL_OPENFORGE}/openforge/recruitment.php`}  className="text-light text-decoration-none">Careers</a></li>
                            <li><a href={`${BASE_URL_OPENFORGE}/openforge/resources.php`} className="text-light text-decoration-none">Resources</a></li>
                            <li><a href={`${BASE_URL_OPENFORGE}/openforge/credits.php`} className="text-light text-decoration-none">Credits</a></li>
                            <li id="last_foot_item"><a href={`${BASE_URL_OPENFORGE}/contact.php`} className="text-light text-decoration-none">Contact Us</a></li>

                        </ul>
                        <p className="mt-4 visitor_counter">Last Updated: <span>{previousDay}</span></p>
                        <p>Visitors :  <span className="visiter_counts">{visitorCount}</span> </p>
                    </div>
                    
                    <div className="col-md-3 mb-3 text-center" id="foot_1">
                        <h2   style={{ fontSize:'1.25rem'}} >Social</h2>
                        <a href="https://www.facebook.com/openforge.gov.in" target="_blank" className="text-light" rel="noreferrer" id="foot_3" ><img src={`${IMAGE_PATH}/facebook.png`} style={{paddingLeft: '13px', paddingRight: '10px'}} alt="facebook.png"/></a>
                        <a href="https://x.com/i/flow/login?redirect_after_login=%2Fopenforge_ind" target="_blank" rel="noreferrer" className="text-light me-3"><img src={`${IMAGE_PATH}/twitter.png`} alt="twitter.png"/></a>
                    </div>
                    
                    <div className="col-md-3 mb-3 text-center" id="foot_2">
                        <h2  style={{ fontSize:'1.25rem'}} >Security</h2>
                        <span className="badge" id="foot_4"><img src={`${IMAGE_PATH}/256sll.png`} alt="256sll.png"/></span>
                    </div>
                    <div className="col-md-3" id="mob_foot1">
                        <h2 className="text-start" style={{ fontSize:'1.25rem'}} >Contact</h2>
                        <img src={`${IMAGE_PATH}/digital-india-logo.png`} alt="Digital India Logo" className="text-start" style={{width: '100px'}}/>
                        <p className="text-start" style={{fontSize:'14px'}}>National eGovernance Division<br></br>
                            Ministry of Electronics &amp; Information Technology (MeitY)<br></br>
                            Government of India<br></br>
                            Copyright ©2024
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    </>
  )
};
